import alt from 'components/Dispatcher';

class OAuthActions {
  constructor() {
    this.generateActions(
      'fetchStatus',
      'fetchStatusLoading',
      'fetchStatusSuccess',
      'fetchStatusError',
      'redirectUrl',
      'redirectUrlSuccess',
      'redirectUrlError'
    );
  }
}

export default alt.createActions(OAuthActions);
